import refreshCart, { sectionsRendering } from './refreshCart';
import { getSectionsToRenderByPDP, getSectionsToRenderByAdd } from './cartSections';
import interactionBlocker from './interactionBlocker';
import handleError from './handleError';
import { quickShopAddToBagTracking } from '../../components/GTMEvents';

/**
 * Quick add item to cart (lightweight version for ProductCard)
 * @param {Object} params
 * @param {String} params.variantId - The variant ID to add
 * @param {String} [params.productName] - Product name for tracking
 * @param {String} [params.productId] - Product ID for tracking
 * @param {String} [params.location] - Some place where Quick Add CTA was went off
 * @returns {Promise<Object>} - Response data with sections and items
 */
export default async function quickAddToCart({ variantId, productName, productId, location }) {
  const formData = new FormData();
  let getSectionsToRender;
  formData.append('items[0][id]', variantId);
  formData.append('items[0][quantity]', 1);

  if (window.location.pathname !== '/cart') {
    getSectionsToRender = getSectionsToRenderByPDP();
  } else {
    getSectionsToRender = getSectionsToRenderByAdd();
  }

  formData.append('sections', getSectionsToRender.map((section) => section.section).join(','));

  // Turn on interaction blocker for cart, in case customers are precisely adding item to cart in cart page
  interactionBlocker(true);

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    handleError(errorData.message);
    // Interaction blocker: unblock cart
    interactionBlocker();
    throw new Error(errorData.message || errorData.description || 'Failed to add to cart');
  }

  const data = await response.json();

  // Update cart sections
  sectionsRendering(data.sections, { cartItemKey: data.items[0].key });

  // Interaction blocker: unblock cart
  interactionBlocker();

  // Open AddToBag modal for non-cart pages. For example, PDP, PLP, Homepage, etc.
  if (window.location.pathname !== '/cart') {
    const atbModal = document.querySelector('add-to-bag');
    if (atbModal) {
      atbModal.openModal();
      atbModal.closeModal();
    }
  }

  setTimeout(async () => {
    quickShopAddToBagTracking(productName, productId);

    // Call GET "cart.js" for getting the current cart state afterwards we have added a new item
    // because of lack of cart data from POST "add.js"
    const responseGetCart = await fetch('/cart.js');
    // Check if the response was successful
    if (!responseGetCart.ok) {
      const errorData = await responseGetCart.json();
      const error = new Error('Network response was not ok');
      error.details = errorData;
      throw error;
    }

    const cartData = await responseGetCart.json();
    refreshCart(cartData, { name: 'addItem', detail: data, quickAdd: { location } }, false);
  }, 0);

  return data;
}
